import { render } from "./Menubar.vue?vue&type=template&id=48fad216&scoped=true"
import script from "./Menubar.vue?vue&type=script&lang=js"
export * from "./Menubar.vue?vue&type=script&lang=js"

import "./Menubar.vue?vue&type=style&index=0&id=48fad216&scoped=true&lang=css"

import exportComponent from "G:\\MET-CS601-Term-Project\\cs601-term-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fad216"]])

export default __exports__